/* eslint-disable @repo/internal/react/no-unsafe-spread-props */
import React from 'react';
import { fg } from '@atlaskit/platform-feature-flags';
import Compiled, { inputCSS as compiledInputCSS } from '../compiled/components/input';
import Emotion, { inputCSS as emotionInputCSS } from '../emotion/components/input';
export var inputCSS = function inputCSS(props) {
  return fg('compiled-react-select') ? compiledInputCSS() : emotionInputCSS(props);
};
var Input = function Input(props) {
  return fg('compiled-react-select') ? /*#__PURE__*/React.createElement(Compiled, props) : /*#__PURE__*/React.createElement(Emotion, props);
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Input;